import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { History } from "history";
import _ from "lodash";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import CorneredCard from "components/CorneredCard";
import AnimatedArrow from "components/AnimatedArrow";
import Button from "components/Button";
import { URLS } from "constants/urlConstants";
import OrderActions from "../orders/actions";
import InvoiceActions from "../invoices/actions";
import NotificationsActions from "../myNotifications/actions";
import { IMeta, IOrder, IInvoice, INotification, IUser } from "models/.";
import { getFormatted, formatProfileName } from "helpers/formatting";

import "./style.scss";

interface IProps {
  local: string;
  roles: string[];
  getOrders: (meta?: IMeta) => void;
  getInvoices: (meta?: IMeta) => void;
  getNotifications: (meta?: IMeta, isCurrent?: boolean) => void;
  orders: IOrder[];
  invoices: IInvoice[];
  notifications: INotification[];
  user: IUser;
  history: History;
}

class Dashboard extends React.Component<IProps> {
  public componentDidMount() {
    const { roles, getOrders, getInvoices, getNotifications } = this.props;
    getNotifications({ pageSize: 2 }, true);
    _.includes(roles, "Orders") && getOrders();
    _.includes(roles, "Financieel") && getInvoices();
  }

  public render() {
    const {
      roles,
      history,
      user: { profile = {} },
      orders,
      invoices,
      notifications,
      local,
    } = this.props;

    return (
      <div id="dashboard-page">
        <h1>
          <FormattedMessage id="WELCOME" /> {formatProfileName(profile.name)}
        </h1>
        <div className="container">
          <CorneredCard size="big" color="red">
            <div className="header">
              <FormattedMessage id="NOTIFICATIONS" tagName="h2" />
              <Link to={URLS.ALL_NOTIFICATIONS_URL}>
                <FormattedMessage id="NOTIFICATIONS_VIEW_ALL" />
              </Link>
            </div>
            {notifications?.map((item, index) => (
              <div
                key={item._id}
                className={classnames("card-raw", {
                  "second-row": index !== 0,
                })}
              >
                <div
                  className={classnames("card-raw-child", {
                    "card-raw-child-important": item.Important,
                  })}
                >
                  <span className="title">{item[`Title_${local}`]}</span>
                  <p className="text">{item[`Text_${local}`]}</p>
                </div>
                <div className="card-raw-button">
                  {item.Files && (
                    <Link
                      to={`${URLS.OPEN_DOCUMENT}/${_.get(item, "Files._id")}`}
                      target="_blank"
                    >
                      <Button className="reversed" icon={<AnimatedArrow />}>
                        VIEW_PDF
                      </Button>
                    </Link>
                  )}
                </div>
              </div>
            ))}
            {(!notifications || !notifications.length) && (
              <div className="message">
                <FormattedMessage id="NOTIFICATIONS_NO_DATA" />
              </div>
            )}
          </CorneredCard>
        </div>

        <div className="container">
          {_.includes(roles, "Orders") && (
            <CorneredCard size="big" color="purple">
              <div className="header">
                <FormattedMessage id="ORDERS_RECENT" tagName="h2" />
              </div>
              {orders.slice(0, 3).map((order) => (
                <div
                  className="card-raw"
                  key={order.Id}
                  onClick={() =>
                    history.push(
                      `${URLS.ORDERS_URL}/${order.Id}?kooptype=${order.RoleId}`
                    )
                  }
                >
                  <span>{order.Number}</span>
                  <span>{getFormatted(order.DateModified, "date")}</span>
                  <span>{order.OtherRelation?.Name}</span>
                  <AnimatedArrow />
                </div>
              ))}
              <div className="link">
                <Link to={URLS.ORDERS_URL}>
                  <FormattedMessage id="ORDERS_VIEW_ALL" />
                </Link>
              </div>
            </CorneredCard>
          )}

          {_.includes(roles, "Financieel") && (
            <CorneredCard size="big" color="yellow">
              <div className="header">
                <FormattedMessage id="INVOICES_RECENT" tagName="h2" />
              </div>
              {invoices
                .slice(0, 3)
                .map(({ Id, Number, InvoiceDate, CounterParty }) => (
                  <div
                    className="card-raw"
                    key={Id}
                    onClick={() => history.push(`${URLS.INVOICES_URL}/${Id}`)}
                  >
                    <span>{Number}</span>
                    <span>{getFormatted(InvoiceDate, "date")}</span>
                    <span>{CounterParty.Name}</span>
                    <AnimatedArrow />
                  </div>
                ))}
              <div className="link">
                <Link to={URLS.INVOICES_URL}>
                  <FormattedMessage id="INVOICES_VIEW_ALL" />
                </Link>
              </div>
            </CorneredCard>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    roles: state.app.roles,
    orders: state.orders.items,
    invoices: state.invoices.items,
    notifications: state.notifications.items,
    user: state.app.user,
    local: state.app.user.profile.Language,
  }),
  {
    getOrders: OrderActions.getOrders,
    getInvoices: InvoiceActions.getInvoices,
    getNotifications: NotificationsActions.getNotifications,
  }
)(Dashboard);
